import React, { useEffect, useState } from 'react';
import { resolvePhotoDataUrl } from './photoStorage';
import { hasHeaderContent } from './formHeader';

// The form's report header as it appears above the questions when a survey is
// filled in, reviewed, or previewed in the builder. The logo is a small square
// pinned to the side the author chose; the text is rendered as text, never as
// markup, so anything typed into it stays inert.
const FormHeaderBanner = ({ header, className = '' }) => {
  const [logoUrl, setLogoUrl] = useState('');
  const logoRef = header?.logo || '';

  useEffect(() => {
    let cancelled = false;
    if (!logoRef) {
      setLogoUrl('');
      return undefined;
    }
    resolvePhotoDataUrl(logoRef)
      .then((url) => {
        if (!cancelled) setLogoUrl(url || '');
      })
      .catch(() => {
        if (!cancelled) setLogoUrl('');
      });
    return () => {
      cancelled = true;
    };
  }, [logoRef]);

  if (!hasHeaderContent(header)) return null;

  const position = header.logoPosition;
  const hasText = !!header.text?.trim();
  // A logo that no longer resolves (removed from storage, still referenced by
  // the form) would otherwise leave an empty bordered box behind.
  if (!hasText && !logoUrl) return null;

  const logo = logoUrl ? (
    <img
      src={logoUrl}
      alt="Form logo"
      className="h-16 w-16 shrink-0 rounded object-contain bg-white/5 border border-gray-600 p-1"
    />
  ) : null;

  const text = hasText ? (
    <div
      className={`whitespace-pre-wrap text-white font-medium leading-snug ${
        position === 'center' ? 'text-center' : 'text-left'
      } ${position === 'right' ? 'flex-1' : ''}`}
    >
      {header.text}
    </div>
  ) : null;

  if (position === 'center') {
    return (
      <div className={`flex flex-col items-center gap-3 ${className}`}>
        {logo}
        {text}
      </div>
    );
  }

  return (
    <div className={`flex items-start gap-4 ${className}`}>
      {position === 'left' ? (
        <>
          {logo}
          {text}
        </>
      ) : (
        <>
          {text || <div className="flex-1" />}
          {logo}
        </>
      )}
    </div>
  );
};

export default FormHeaderBanner;
